import React, { useRef } from "react";
import { Button, Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import CoursePlayerShortCourses from "./CoursePlayerShortCourses";
import { PrintOutlined } from "@mui/icons-material";
import ReactToPrint from "react-to-print";

const CoursePlayerPrintButton = ({ courseTitle, modules }) => {
  const { t } = useTranslation();
  const printRef = useRef(null);

  return (
    <>
      <ReactToPrint
        trigger={() => {
          return (
            <Button
              color="primary"
              startIcon={<PrintOutlined />}
              disabled={!modules || modules.length === 0}
            >
              {t("coursePlayer.tableOfContentsTab.print")}
            </Button>
          );
        }}
        content={() => printRef.current}
      />
      <Box display="none">
        <Box display="flex" flexDirection="column" p={5} ref={printRef}>
          <Typography
            variant="h2"
            color="textSecondary"
            sx={{ textAlign: "center", pb: 3 }}
          >
            {courseTitle}
          </Typography>
          {modules && (
            <CoursePlayerShortCourses
              shortCourses={modules}
              showProgress={false}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default CoursePlayerPrintButton;

CoursePlayerPrintButton.propTypes = {
  courseTitle: PropTypes.string,
  modules: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      activities: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          status: PropTypes.string,
          title: PropTypes.string
        })
      )
    })
  )
};
